import * as React from 'react';
import { SVGProps } from 'react';

const SvgThreads = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.75 14.25v-1.5h-1.5v-1.5h1.5v-1.5h-1.5v-1.5h1.5v-1.5h1.5v1.5h1.5v-1.5h1.5v1.5h1.5v1.5h-1.5v1.5h1.5v1.5h-1.5v1.5h-1.5v-1.5h-1.5v1.5h-1.5Zm3-4.5h-1.5v1.5h1.5v-1.5Z'
      fill='#000'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.5 5.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75H11v1.5H4.5A2.25 2.25 0 0 1 2.25 15V6A2.25 2.25 0 0 1 4.5 3.75h15A2.25 2.25 0 0 1 21.75 6v9a2.25 2.25 0 0 1-2.25 2.25h-4.565l-1.784 3.122-1.302-.744 2.216-3.878H19.5a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.75-.75h-15Z'
      fill='#000'
    />
  </svg>
);

export default SvgThreads;
